'use strict';

var React = require('react/addons');
var classSet = React.addons.classSet;

/* Stores */
var LanguageStore = require('stores/language');

/* Components */
var Modal = require('components/ui/modal');
var ButtonGroup = require('components/ui/button-group');
var Button = require('components/ui/button');
var TextField = require('components/ui/text-field');

var LinkEditor = React.createClass({
  displayName: 'LinkEditor',

  componentDidMount: function componentDidMount() {
    var component = this;
    component.refs.linkField.focus();
  },

  render: function render() {
    var component = this;

    var _component$props = component.props;
    var className = _component$props.className;
    var url = _component$props.url;
    var title = _component$props.title;
    var onCancel = _component$props.onCancel;
    var onSaveLink = _component$props.onSaveLink;
    var onRemoveLink = _component$props.onRemoveLink;

    /* Translations */
    var translate = LanguageStore.translate;

    var baseTranslationKey = 'translation_editor_';

    var titleTranslationKey = 'translation_editor_' + title;
    var titleTranslation = translate(titleTranslationKey);

    var linkFieldTranslationKey = baseTranslationKey + 'link';
    var addLinkButtonTranslationKey = baseTranslationKey + 'add_link';
    var removeLinkButtonTranslationKey = baseTranslationKey + 'remove_link';

    // Remove button (conditional)

    var removeLinkButton = url && url.length ? React.createElement(Button, {
      translationKey: removeLinkButtonTranslationKey,
      onClick: onRemoveLink }) : null;

    // ClassName
    var classes = {};
    classes['link-editor-component'] = true;
    classes[className] = true;

    return React.createElement(
      Modal,
      { className: classSet(classes), onSubmit: component._onSubmit, onCancel: onCancel },
      React.createElement(
        'div',
        { className: 'title' },
        titleTranslation
      ),
      React.createElement(TextField, { ref: 'linkField', translationKey: baseTranslationKey + "link", value: url, onChange: component._onChange }),
      React.createElement(
        ButtonGroup,
        null,
        React.createElement(Button, { translationKey: 'cancel', className: 'cancel', onClick: onCancel }),
        removeLinkButton,
        React.createElement(Button, { className: 'submit', translationKey: baseTranslationKey + "add_link", onClick: component._onSubmit })
      )
    );
  },

  _onChange: function _onChange() {
    this.value = this.refs.linkField.value;
  },

  _onSubmit: function _onSubmit() {

    var component = this;
    var props = component.props;

    if (props.onSaveLink) {
      props.onSaveLink();
    }
  }
});

module.exports = LinkEditor;


/** WEBPACK FOOTER **
 ** ../~/babel-loader!./js/components/project/link-editor.js
 **/